export const GC_REQUIREMENT_TITLES = {
  requirePreferredBedroomCount: {
    PRIMARY: 'Require Bedroom Count',
    SECONDARY:
      'Require a preferred bedroom count when requesting an application for a prospect.',
  },
  requireLeaseTerm: {
    PRIMARY: 'Require Lease Term',
    SECONDARY:
      'Require a lease term when requesting an application for a prospect.',
  },
  requireProspectMoveInDate: {
    PRIMARY: 'Require Move-in Date',
    SECONDARY:
      'Require a move-in date when requesting an application for a prospect.',
  },
  requireProspectFloorplan: {
    PRIMARY: 'Require Floor Plan',
    SECONDARY:
      'Require a preferred floor plan when requesting an application for a prospect.',
  },
  requirePreferredUnit: {
    PRIMARY: 'Require Preferred Unit',
    SECONDARY:
      'Require a preferred unit when requesting an application for a prospect.',
  },
};
